<template>
  <v-container fluid>
    <!-- <v-card style="margin-bottom: 20px;">
      <v-card-title>Applications</v-card-title>
      <v-card-text>
        <p>
          Applications are White Labeled applications running on the system.
        </p>
        <p>An Example of an Application is CritterPic</p>
      </v-card-text>
    </v-card>-->
    <v-card :loading="applicationsLoading">
      <v-toolbar color="primary" dark>
        Applications
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon dark v-bind="attrs" v-on="on">mdi-information-variant</v-icon>
          </template>
          <p>Applications are White Labeled applications running on the system.</p>
          <p>An Example of an Application is CritterPic</p>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchApplications"
          label="Search"
          single-line
          hide-details
          prepend-icon="mdi-magnify"
          clearable
          v-on:input="onQuickFilterChanged()"
        ></v-text-field>
      </v-toolbar>
      <expandedToolbar :newButton="true" @newButtonClick="newApplicationDialog = true" />
      <v-card-text v-if="applications">
        <v-row>
          <v-col style="height: calc(100vh - 230px) !important;" cols="12">
            <ag-grid-vue
              :style="{ width, height }"
              class="ag-theme-alpine"
              :defaultColDef="defaultColDef"
              :columnDefs="columnDefs"
              :rowData="rowData"
              :animateRows="true"
              rowSelection="multiple"
              @grid-ready="onGridReady"
              @cellDoubleClicked="onCellDoubleClick"
            ></ag-grid-vue>
          </v-col>
        </v-row>
        <!-- <v-data-table
          :headers="applicationsHeaders"
          :items="applications"
          :search="searchApplications"
          :items-per-page="10"
          item-key="name"
          sort-by="id"
          :sort-desc="true"
          class="elevation-0"
          :loading="applicationsLoading"
        >
          <template v-slot:item.actions="{ item }">
            <div>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="openManageApplication(item)">
                    <v-list-item-title>Manage</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
        </v-data-table>-->
      </v-card-text>
    </v-card>
    <v-dialog v-model="manageApplicationDialog" persistent max-width="600px">
      <v-card v-if="applications" tile>
        <v-toolbar color="primary" dark>
          Manage Application
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            icon
            dark
            @click="
              manageApplicationDialog = false;
              applicationFormData = {};
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="applicationFormData.prefix" label="Application Prefix"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="applicationFormData.name" label="Application Name"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="applicationFormData.hostUrl" label="Host Url"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="manageApplicationLoading" @click="saveApplication()" color="success">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newApplicationDialog" persistent max-width="600px">
      <v-card v-if="applications" tile>
        <v-toolbar color="primary" dark>
          New Application
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="newApplicationDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="applicationFormData.name" label="Application Name"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="applicationFormData.prefix"
                  label="Application Prefix (3 Letters Max)"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="applicationFormData.hostUrl" label="Host Url"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="newApplicationLoading"
            @click="generateNewApplication()"
            color="success"
          >Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="aGGridActionMenu" persistent max-width="300px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          Action Menu
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="updateAGGridActionMenu()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-list dense>
                  <!-- <v-list-item :to="'/dashboard'">
                    <v-list-item-action>
                      <v-icon>mdi-account-box</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Event Profile</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>-->
                  <v-list-item @click="openManageApplication()">
                    <v-list-item-action>
                      <v-icon>mdi-cogs</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Manage Application</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import AppBar from "@/components/AppBar";
  import agGridActionButton from "@/components/agGridActionButton";
  import expandedToolbar from "@/components/expandedToolbar.vue";
  import { AgGridVue } from "ag-grid-vue";
  import moment from "moment";

  export default {
    components: { AppBar, AgGridVue, agGridActionButton, expandedToolbar },
    computed: {
      ...mapGetters([
        "currentUser",
        "currentUserData",
        "aGGridActionMenu",
        "selectedRowData",
        "applications",
        "applicationsLoading",
      ]),
    },
    props: {
      source: String,
    },
    data: () => ({
      // AG-Grid
      columnDefs: null,
      rowData: null,
      columnApi: null,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        autoHeight: true,
      },
      width: "100%",
      height: "100%",

      drawer: null,
      applicationsHeaders: [
        {
          text: "ID",
          align: "left",
          sortable: true,

          value: "id",
          width: "80px",
        },
        { text: "Prefix", value: "prefix", width: "100px" },
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Devices",
          value: "devices",
        },
        {
          text: "Organizations",
          value: "organizations",
        },
        {
          text: "Active Deployments",
          value: "deployments",
        },
        {
          text: "Created At",
          value: "created_at",
        },
        {
          text: "Updated At",
          value: "updated_at",
        },
        {
          text: "Actions",
          value: "actions",
        },
      ],
      searchApplications: "",
      //New Applications
      newApplicationDialog: false,
      newApplicationLoading: false,
      //Manage Applications
      manageApplicationDialog: false,
      manageApplicationLoading: false,
      //ApplicationFormData
      applicationFormData: {},
    }),
    beforeMount() {
      this.columnDefs = [
        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "agGridActionButton",
        },
        {
          headerName: "ID",
          field: "id",
        },
        { headerName: "Prefix", field: "prefix" },
        {
          headerName: "Name",
          field: "name",
        },
        {
          headerName: "Url",
          field: "hostUrl",
        },
        {
          headerName: "Devices",
          field: "devices",
        },
        {
          headerName: "Organizations",
          field: "organizations",
        },
        {
          headerName: "Active Deployments",
          field: "deployments",
        },
        {
          headerName: "Created At",
          field: "created_at",
          valueFormatter: createdAtFormatter,
        },
        {
          headerName: "Updated At",
          field: "updated_at",
          valueFormatter: updatedAtFormatter,
        },
      ];
      this.$store.dispatch("loadApplications").then(() => {
        this.rowData = this.applications;
        var allColumnIds = [];
        this.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.columnApi.autoSizeColumns(allColumnIds, false);
      });
      if (this.aGGridActionMenu == true) {
        this.$store.dispatch("setAGGridActionMenuState", {});
      }
    },
    mounted() {},
    watch: {
      applications: function (oldApp, newApp) {
        this.rowData = this.applications;
      },
    },
    methods: {
      onQuickFilterChanged() {
        this.gridApi.setQuickFilter(this.searchApplications);
      },
      onGridReady(params) {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
      },
      autoSizeColumnsAGGRID() {
        // this.gridApi.sizeColumnsToFit();
        var allColumnIds = [];
        this.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.columnApi.autoSizeColumns(allColumnIds, false);
      },
      onCellDoubleClick(cell) {
        this.$store.dispatch("setAGGridActionMenuState", cell.data);
      },
      updateAGGridActionMenu() {
        this.$store.dispatch("setAGGridActionMenuState", {});
      },
      generateNewApplication() {
        this.newApplicationLoading = true;
        this.$store
          .dispatch("newApplication", this.applicationFormData)
          .then((result) => {
            this.newApplicationLoading = false;
            this.newApplicationDialog = false;
            this.$swal({
              title: "Success!",
              text: `${this.applicationFormData.name} has been Created`,
              type: "success",
              confirmButtonText: "Ok",
            });
          });
      },
      openManageApplication() {
        this.applicationFormData = {
          id: this.selectedRowData.id,
          prefix: this.selectedRowData.prefix,
          name: this.selectedRowData.name,
          hostUrl: this.selectedRowData.hostUrl,
        };
        this.updateAGGridActionMenu();
        this.manageApplicationDialog = true;
      },
      saveApplication() {
        this.manageApplicationLoading = true;
        this.$store
          .dispatch("saveApplication", this.applicationFormData)
          .then((result) => {
            this.manageApplicationLoading = false;
            this.manageApplicationDialog = false;
            this.$swal({
              title: "Success!",
              text: `${this.applicationFormData.name} was Saved`,
              type: "success",
              confirmButtonText: "Ok",
            });
            this.applicationFormData = {};
          });
      },
    },
  };
  window.createdAtFormatter = function createdTimeFormatter(params) {
    if (params.data.created_at) {
      return moment
        .utc(params.data.created_at)
        .local()
        .format("MMMM Do YYYY, h:mm:ss a");
    } else {
      return "";
    }
  };
  window.updatedAtFormatter = function createdTimeFormatter(params) {
    if (params.data.updated_at) {
      return moment
        .utc(params.data.updated_at)
        .local()
        .format("MMMM Do YYYY, h:mm:ss a");
    } else {
      return "";
    }
  };
</script>
